var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 28H24.6668C23.9304 28 23.3335 27.403 23.3335 26.6666V13.3333C23.3335 12.5969 23.9304 12 24.6668 12H26.0002C26.7366 12 27.3335 12.5969 27.3335 13.3333V26.6666C27.3335 27.403 26.7366 28 26.0002 28Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.99998H26V7.99998",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 4.66665C25.3333 4.66665 20 11.3333 6 16",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 28H15.3333C14.5969 28 14 27.403 14 26.6666V18C14 17.2636 14.5969 16.6666 15.3333 16.6666H16.6667C17.4031 16.6666 18 17.2636 18 18V26.6666C18 27.403 17.4031 28 16.6667 28Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 28H5.99984C5.26346 28 4.6665 27.403 4.6665 26.6666V21.3333C4.6665 20.5969 5.26346 20 5.99984 20H7.33317C8.06954 20 8.6665 20.5969 8.6665 21.3333V26.6666C8.6665 27.403 8.06954 28 7.33317 28Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.a175b01157c65338e0e65ebef0375ab1.svg";
export { ForwardRef as ReactComponent };